import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from '@mui/material';
import { DragOverlay } from '@dnd-kit/core';
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import FontIcon from 'app/components/FontIcon/FontIcon';
import Draggable from 'app/pages/Project/Settings/Dashboards/Draggable';
import { DraggingItem } from 'app/pages/Project/Settings/Dashboards/DraggingItem';
import ExpansionPanel from 'app/components/ExpansionPanel/ExpansionPanel.jsx';
import classes from 'app/pages/Project/Settings/Dashboards/WidgetsSelection/styles.module.scss';
import { widgetsList, widgetsGroups } from 'app/pages/Project/Settings/Dashboards/widgetsList';
import { openModal } from 'app/components/Modal/openModal';
import ModalWidgetInformation from '../ModalWidgetInformation/ModalWidgetInformation';
import { MUIButton } from 'app/components/Form';
const WidgetsSelection = () => {
    const handleSeeWidgetInformations = (widget) => (e) => {
        e.stopPropagation();
        return openModal(_jsx(ModalWidgetInformation, { widget: widget }));
    };
    return (_jsxs("div", { className: classes.container, children: [_jsx("h3", { children: "Widgets" }), _jsx(List, { component: "nav", children: widgetsGroups.map((group) => {
                    const { id: groupId, name: groupName } = group;
                    const draggableWidgets = widgetsList.filter((widget) => widget.groupId === groupId);
                    return (_jsx(ExpansionPanel, { title: groupName, style: { width: '100%' }, children: _jsx(List, { component: "div", disablePadding: true, sx: { width: '100%', padding: '10px 30px' }, children: draggableWidgets.map((widget, i) => {
                                const { id: widgetId, defaultName, type } = widget;
                                return (_jsxs("div", { style: { width: '100%', display: 'flex', justifyContent: 'space-between' }, children: [_jsxs(Draggable, { id: widgetId, data: { name: defaultName, widgetType: type }, style: {
                                                marginBottom: i !== draggableWidgets.length - 1 ? '20px' : 0,
                                                fontSize: '16px',
                                                cursor: 'grab',
                                            }, children: [_jsx(FontIcon, { icon: "fas-grip-vertical", className: classes.icon }), _jsx("span", { children: defaultName })] }), _jsx(MUIButton, { tooltip: "See widget informations", style: {
                                                minWidth: 25,
                                                minHeight: 25,
                                                width: 25,
                                                height: 25,
                                                borderRadius: 25,
                                                padding: 0,
                                                boxShadow: 'none',
                                                backgroundColor: 'transparent',
                                                margin: 'auto 0 auto auto',
                                            }, children: _jsx(FontIcon, { className: "fontSize18", icon: "fas-info-circle", style: { color: 'grey' }, onClick: handleSeeWidgetInformations(widget) }) }), _jsx(DragOverlay, { dropAnimation: null, modifiers: [snapCenterToCursor], children: _jsx(DraggingItem, {}) })] }, widgetId));
                            }) }) }, groupId));
                }) })] }));
};
export default WidgetsSelection;
